import React from 'react'

import useWindowSize from '../../hooks/windowsize';
export default function Container({children,offset=64}) {
    const windowsize = useWindowSize();
    const container = { display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', height: windowsize.innerHeight - offset, }
  
    return (
        <div style={{ heigth: '100%', width: '100%' }} style={container}>
             {children}
        </div>
    )
}
